var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChevronArrowCorner = function SvgIconsChevronArrowCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.667 2c.342 0 .623.257.662.589l.004.078v4.666c0 1.065.833 1.936 1.883 1.997l.117.003h6.39L9.529 7.138c-.24-.24-.26-.618-.056-.88l.056-.063c.24-.24.618-.259.88-.055l.062.055 3.334 3.334c.023.023.045.048.064.074l.048.074.036.075.023.07.02.1L14 10l-.002.05-.011.084-.02.074-.03.074-.034.065-.043.062-.026.031-.03.031-3.333 3.334c-.26.26-.682.26-.942 0-.24-.24-.26-.619-.056-.88l.056-.063 2.194-2.195h-6.39c-1.792 0-3.254-1.415-3.33-3.19L2 7.334V2.667C2 2.298 2.298 2 2.667 2z"
  })));
};
export default SvgIconsChevronArrowCorner;